import { z } from 'zod';
import axios from 'axios';

const API_URL = 'http://localhost:3030';

// Esquema para los datos generales
export const generalDataSchema = z.object({
  orgNom: z.string().min(1, { message: 'El nombre del organismo es requerido' }),
  orgCuit: z.number({ required_error: 'El CUIT es requerido', invalid_type_error: 'El CUIT debe ser un número' })
    .int({ message: 'El CUIT debe ser un número entero' })
    .min(10000000000, { message: 'El CUIT debe tener 11 dígitos' })
    .max(99999999999, { message: 'El CUIT debe tener 11 dígitos' }),
  orgLote: z.string().optional().nullable(),
  periodoAnio: z.number({ required_error: 'El año es requerido', invalid_type_error: 'El año debe ser un número' })
    .int({ message: 'El año debe ser un número entero' })
    .min(2000, { message: 'El año debe ser mayor o igual a 2000' })
    .max(2100, { message: 'El año debe ser menor o igual a 2100' }),
  periodoMes: z.number({ required_error: 'El mes es requerido', invalid_type_error: 'El mes debe ser un número' })
    .int({ message: 'El mes debe ser un número entero' })
    .min(1, { message: 'El mes debe estar entre 1 y 12' })
    .max(12, { message: 'El mes debe estar entre 1 y 12' }),
  tipoCod: z.number({ required_error: 'El código de tipo es requerido', invalid_type_error: 'El código de tipo debe ser un número' })
    .int({ message: 'El código de tipo debe ser un número entero' }),
  titulo: z.string().optional().nullable(),
  transferidas: z.boolean().optional().default(false),
  tipoCargo: z.string().default('sueldo'),
});

// Esquema para los registros del CSV
export const csvRecordSchema = z.object({
  tipoDoc: z.number().int().min(1).max(4),
  nroDoc: z.number().int().positive(),
  genero: z.number().int().min(1).max(2),
  cuil: z.number().int().positive(),
  fechaNac: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato de fecha inválido (AAAA-MM-DD)'),
  apellidos: z.string().min(1),
  nombres: z.string().min(1),
  escalafon: z.string().min(1),
  agrup: z.string().min(1),
  cargo: z.string().refine(async (codigo) => {
      try {
          const response = await axios.get(`${API_URL}/api/cargo/${codigo}`);
          return response.status === 200;
      } catch (error) {
          return false;
      }
  }, 'El código de cargo no está en el nomenclador'),
  claseCargo: z.number().int().min(0).max(3),
  porcentajeSub: z.number().min(0).max(100),
  fechaIngreso: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato de fecha inválido (AAAA-MM-DD)'),
  revista: z.number().int().min(1).max(8),
  aporte: z.number().min(0),
  contribucion: z.number().min(0),
  remunerativo: z.number().min(0),
  noRemunerativo: z.number().min(0),
  asigFliares: z.number().min(0),
  pjeAporte: z.number().min(0).max(100),
  pjeContrib: z.number().min(0).max(100),
  cantDiasPorpSac: z.number().int().min(0).max(180),
  amparo: z.boolean(),
});